import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createOrganisationApi, getOrganisationApi, updateOrganisationApi } from "./organisationApi";


export const getOrganisationRequest = createAsyncThunk(
  "getOrganisationRequest/organisation",
  async () => {
    try {
      const response = await getOrganisationApi();
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const createOrganisationRequest = createAsyncThunk(
  "createOrganisationRequest/organisation",
  async (payload: any) => {
    try {
      const response = await createOrganisationApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const updateOrganisationRequest = createAsyncThunk(
  "updateOrganisationRequest/organisation",
  async (payload: any) => {
    try {
      const response = await updateOrganisationApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface IInitialState {
  organisationList: any[];
  organisationPost: any;
  organisationUpdate: any;
  message: string;
  isSuccess: boolean;
  pageIsLoading: boolean;
}

const initialState: IInitialState = {
  organisationList: [],
  organisationPost: {},
  organisationUpdate: {},
  message: "",
  isSuccess: false,
  pageIsLoading: false,
};

const organisationSlice = createSlice({
  name: "organisation",
  initialState: initialState,
  reducers: {
    resetMessageOrganisation: (state) => {
      state.message = "";
    },
    resetSuccessOrganisation: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers(builder) {
    // get department reducer
    builder.addCase(getOrganisationRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getOrganisationRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.organisationList = action.payload.data;
        state.pageIsLoading = false;
      } else {
        // state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getOrganisationRequest.rejected, (state) => {
      state.pageIsLoading = false;
    });

    // create department reducer
    builder.addCase(createOrganisationRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(createOrganisationRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.organisationPost = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(createOrganisationRequest.rejected, (state) => {
      state.message = "someting went wrong";
      state.pageIsLoading = false;
    });

    // update department reducer
    builder.addCase(updateOrganisationRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateOrganisationRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.organisationUpdate = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateOrganisationRequest.rejected, (state) => {
      state.message = "someting went wrong";
      state.pageIsLoading = false;
    });
  },
});

export const { resetMessageOrganisation, resetSuccessOrganisation } =
  organisationSlice.actions;
export default organisationSlice.reducer;
